import { useResourceShow } from '@koopajs/react';
import { ICommittee } from 'types';

export const isCustomResNumFormat = (committeeId: string): boolean => {
  const { resource: committee } = useResourceShow<ICommittee>({ path: 'committees', id: committeeId });

  return committee?.resolutionNumberFormat === 'custom';
};
